import { translate } from 'hooks/useTranslate';
import { Society } from 'types/Society';

type GetPageDescriptionProps = {
  society: Society;
};

export const getPageDescription = ({
  society,
}: GetPageDescriptionProps): string => {
  if (!society) return '';

  const societyName = society.name || '';
  const partnersCount = society?.partnersCount?.active || 0;

  return `${societyName} ${translate('HavePartners', {
    count: partnersCount,
  })}`.trim();
};
